
    var riot = require('riot')
    //src: starling/src/tags/image-size-menu.html
riot.tag2('image-size-menu',
  '<ul class="menu-list" if="{this.nodeTag}"> <li onclick="{changeImageSize.bind(this, \'small\')}" class="icon-container"> <div class="icon-wrapper"> <i class="image-size-icon icon small {this.getImageSize() == \'small\' ? \'selected\' : \'\'}"></i> </div> <span>Small</span> </li> <li onclick="{changeImageSize.bind(this, \'medium\')}" class="icon-container {this.getMaxOriginalDimension() && this.getMaxOriginalDimension() < this.IMAGE_SIZES.small ? \'disabled\' : \'\'}"> <div class="icon-wrapper"> <i class="image-size-icon icon medium {this.getImageSize() == \'medium\' ? \'selected\' : \'\'}"></i> </div> <span>Medium</span> </li> <li onclick="{changeImageSize.bind(this, \'large\')}" class="icon-container {this.getMaxOriginalDimension() && this.getMaxOriginalDimension() < this.IMAGE_SIZES.medium ? \'disabled\' : \'\'}"> <div class="icon-wrapper"> <i class="image-size-icon icon large {this.getImageSize() == \'large\' ? \'selected\' : \'\'}"></i> </div> <span>Large</span> </li> <li if="{showCustomOption()}" onclick="{changeImageSize.bind(this, \'custom\')}" class="icon-container"> <div class="icon-wrapper"> <i class="material-icons image-size-icon icon custom {this.getImageSize() == \'custom\' ? \'selected\' : \'\'}">photo_size_select_small</i> </div> <span>Custom</span> </li> </ul>',
  '',
  'ref="main" class="hidden" riot-style="{this.getStyle()}" onmouseenter="{this.handlePanelMouseEnter}"', function(opts) {
'use strict';

var _this = this;

var _fileAttachmentsUi = require('lib/file-attachments-ui');

var _delayHandler = require('lib/delay-handler');

var _constants = require('lib/constants.js');

this.canvas = opts.canvas;
this.canvas.imageSizeMenu = this;
this.isOpen = false;
this.nodeTag = null;
this.origin = null;
this.IMAGE_SIZES = _constants.IMAGE_SIZES;
this.summon = function (_ref) {
  var nodeTag = _ref.nodeTag,
      referenceEl = _ref.referenceEl,
      positionToLeft = _ref.positionToLeft,
      origin = _ref.origin;

  var rect = referenceEl.getBoundingClientRect();
  _this.nodeTag = nodeTag;
  _this.positionToLeft = positionToLeft;
  _this.origin = origin;

  if (_this.fromOrigin('toolbar')) {
    _this.y = rect.bottom;
    _this.x = rect.left;
  } else {
    _this.y = rect.top;
    _this.x = rect.right;
    if (positionToLeft) {
      _this.x = window.innerWidth - rect.left;
    }
  }

  if (positionToLeft) {
    _this.style = 'position: fixed; top: ' + _this.y + 'px; right: ' + _this.x + 'px';
  } else {
    _this.style = 'position: fixed; top: ' + _this.y + 'px; left: ' + _this.x + 'px';
  }

  _this.refs.main.classList.add('visible');
  _this.refs.main.classList.remove('hidden');
  _this.isOpen = true;
  _this.update();
};

this.fromOrigin = function (name) {
  return _this.origin === name;
};

this.getStyle = function () {
  return _this.style;
};

this.hide = function () {
  _this.isOpen = false;
  _this.selected = null;
  _this.nodeTag = null;
  _this.origin = null;
  _this.refs.main.classList.remove('visible');
  _this.refs.main.classList.add('hidden');
};

this.getImageSize = function () {
  if (!_this.nodeTag) {
    return;
  }
  return _fileAttachmentsUi.fui.getImageSize(_this.nodeTag.id);
};

this.getMaxOriginalDimension = function () {
  if (!_this.nodeTag) {
    return;
  }
  return _fileAttachmentsUi.fui.getMaxOriginalDimension(_this.nodeTag.id);
};

this.changeImageSize = function (size, e) {
  e.stopPropagation();
  e.stopImmediatePropagation();
  if (size === 'custom') {
    _this.canvas.setActiveImageNode(_this.nodeTag);
    _this.canvas.hidePopups({ keepActiveImage: true });
    return;
  }

  _this.canvas.defaultImageSize = size;

  _fileAttachmentsUi.fui.changeImageSize({
    nodeId: _this.nodeTag.id,
    size: size
  });
};

this.showCustomOption = function () {
  if (!_this.nodeTag) return false;
  return _fileAttachmentsUi.fui.hasImageAttachment(_this.nodeTag.id);
};

this.handlePanelMouseEnter = function () {
  _delayHandler.delayHandler.clearDelayFor('submenus');
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('image-size-menu')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/image-size-menu.html
// module id = 675
// module chunks = 0